/* eslint-disable react/display-name */
import { EntityId } from '@smartsheet-dataflow/formjs-react';
import { MultiSelect } from '@smartsheet/lodestar-core';
import React, {
  KeyboardEventHandler,
  useCallback,
  useMemo,
  useState,
} from 'react';

interface ChipType extends Record<string, string> {
  label: string;
  value: string;
}

interface InputStringArrayProps extends EntityId {
  value: string[];
  placeholder?: string;
  onChange: (value?: string[]) => void;
}

export const InputStringArray = React.memo(
  ({
    id,
    placeholder = '+ value',
    value = [],
    onChange,
  }: InputStringArrayProps) => {
    const [inputValue, setInputValue] = useState<string>('');

    const handleKeyDown: KeyboardEventHandler<Element> = event => {
      if (!inputValue) return;
      switch (event.key) {
        case 'Enter':
        case 'Tab':
          setInputValue('');
          onChange([...value, inputValue]);
          event.preventDefault();
          break;
        default:
          break;
      }
    };

    const getOptionLabel = useCallback((chip: ChipType) => chip.label, []);
    const onChangeHandler = useCallback(
      chips =>
        onChange(
          (chips && chips.map((chip: { value: any }) => chip.value)) || []
        ),
      [onChange]
    );

    const values = value.map(v => ({ label: v, value: v }));
    const memoizedEmptyOptionsList = useMemo(() => [], []);

    return (
      <MultiSelect
        id={id}
        value={values}
        options={memoizedEmptyOptionsList}
        placeholder={placeholder}
        onChange={onChangeHandler}
        getOptionLabel={getOptionLabel}
        inputValue={inputValue}
        onInputChange={setInputValue}
        onKeyDown={handleKeyDown}
        onBlur={event => {
          if (inputValue) {
            setInputValue('');
            onChange([...value, inputValue]);
            event.preventDefault();
          }
        }}
        menuIsOpen={false}
        components={{
          DropdownIndicator: null,
          ClearIndicator: null,
        }}
      />
    );
  }
);
